// extracted by mini-css-extract-plugin
export var wrapper = "Community-module--wrapper--1LCnO";
export var grid = "Community-module--grid--3lnHs";
export var imgbox = "Community-module--imgbox--Lkgkz";
export var cover = "Community-module--cover--1dCXu";
export var snsIcon = "Community-module--sns-icon--2a5u9";
export var more = "Community-module--more--1oamF";
export var fromLeftBottom = "Community-module--from-left-bottom--2CnwD";
export var fromTop = "Community-module--from-top--DFwIl";
export var fromLeft = "Community-module--from-left--2J7al";
export var fromBottom = "Community-module--from-bottom--ChLfc";
export var fromRight = "Community-module--from-right--2q5Mj";